import Navbar from './Navbar';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import Create from './Create';
import EntryDetails from './EntryDetails';
import NotFound from './404';
import About from './About';
import YouTubeLogin from './components/YouTube/YouTubeLogin';
import Subscribe from './components/YouTube/Subscribe';
import Admin from './pages/Admin';
import RaffleWinner from './pages/RaffleWinner';
import EepromTools from './pages/EepromTools';
import Landing from './pages/Landing';
import F430Cluster from './pages/eeprom/F430Cluster';
import F430Airbag from './pages/eeprom/F430Airbag';
import AuthCallback from './pages/AuthCallback';
import Login from './pages/Login';
import Merch from './pages/Merch';
import Raffle from './pages/Raffle';
import PartsLanding from './pages/PartsLanding';
import PartsDiagram from './pages/PartsDiagram';
import { AuthProvider, useAuth } from './auth/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Redirect to="/login" />;
  }

  if (!isAdmin) {
    return <Redirect to="/" />;
  }

  return children;
};

// surround app with router so all child components can use it
function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <div className="content">
            <Switch>
              <Route exact path="/">
                <Landing />
              </Route>
              <Route exact path="/login">
                <Login />
              </Route>
              <Route exact path="/auth/callback">
                <AuthCallback />
              </Route>
              <Route exact path="/raffle">
                <Raffle />
              </Route>
              <Route exact path="/raffle/enter">
                <Create />
              </Route>
              <Route path="/raffle/entries/:id">
                <EntryDetails />
              </Route>
              <Route path="/raffle/youtube">
                <YouTubeLogin />
              </Route>
              <Route path="/raffle/subscribe">
                <Subscribe />
              </Route>
              <Route path="/parts/porsche/:modelSlug/:sectionCode">
                <PartsDiagram />
              </Route>
              <Route path="/parts">
                <PartsLanding />
              </Route>
              <Route path="/merch">
                <Merch />
              </Route>
              <Route path="/eeprom/f430-cluster">
                <F430Cluster />
              </Route>
              <Route path="/eeprom/f430-airbag">
                <F430Airbag />
              </Route>
              <Route path="/eeprom">
                <EepromTools />
              </Route>
              <Route exact path="/admin/raffle-winner">
                <AdminRoute>
                  <RaffleWinner />
                </AdminRoute>
              </Route>
              <Route path="/admin">
                <AdminRoute>
                  <Admin />
                </AdminRoute>
              </Route>
              <Route path="/about">
                <About />
              </Route>
              <Route path="*">
                <NotFound />
              </Route>
            </Switch>
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
